import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import {
  Button,
} from 'reactstrap';
import AccountPlusIcon from 'mdi-react/AccountPlusIcon';
import classNames from 'classnames';
import { withTranslation } from 'react-i18next';
import throttle from 'lodash.throttle';
import RenderDatePickerField from '../../../../shared/components/form/DatePicker';
import { ThemeProps } from '../../../../shared/prop-types/ReducerProps';
import SearchBox from '../../../../shared/components/SearchBox';
import { typesFilter } from '../constants/options';

const activeOptions = [
  { value: '', id: 'all-customers-filter', label: 'All Customers' },
  { value: 'actives', id: 'active-customers-filter', label: 'Active Customers' },
  { value: 'inactives', id: 'inactive-customers-filter', label: 'Inactive Customers' },
];

const customersPageSidebarImg = `${process.env.PUBLIC_URL}/img/sidebar_img.svg`;

class CustomerSidebar extends Component {
  static propTypes = {
    openNewCustomerModel: PropTypes.func.isRequired,
    updateFilter: PropTypes.func.isRequired,
    activesFilter: PropTypes.string.isRequired,
    startDate: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]),
    endDate: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]),
    keyword: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
    sortBy: PropTypes.string.isRequired,
    dir: PropTypes.string.isRequired,
    theme: ThemeProps.isRequired,
    t: PropTypes.func.isRequired,
    rtl: PropTypes.string.isRequired,
  };

  static defaultProps = {
    startDate: null,
    endDate: null,
  };

  constructor(props) {
    super(props);
    this.handleKeywordChange = throttle(this.handleKeywordChange, 400);
  }

  handleFilterChange = (event) => {
    const { updateFilter } = this.props;
    updateFilter(event.target.value, event.target.name);
  };

  handleDateChange = (value, name) => {
    const { updateFilter } = this.props;
    updateFilter(value, name);
  };

  handleTypeChange = ({ value }) => {
    const { updateFilter } = this.props;
    updateFilter(value, 'type');
  };

  handleKeywordChange = (value, name) => {
    const { updateFilter } = this.props;
    updateFilter(value, name);
  };

  render() {
    const {
      openNewCustomerModel,
      activesFilter, startDate, endDate, keyword, type, sortBy, dir, theme, t, rtl,
    } = this.props;

    return (
      <div className="customers-page__input-new">
        <div className="customers-page__sidebar">
          <img className="customers-page_sidebar-image" src={customersPageSidebarImg} alt="sidebar-img" />
          <Button className="customers-page__btn-add-new" onClick={openNewCustomerModel}>
            <AccountPlusIcon /> {t('customers.add_new')}
          </Button>
          <div className="customers-page__date-filter">
            <p className="title">{t('customer_filter.status')}</p>
            <ul className="customers-page__date-filter-list">
              {activeOptions.map(({ value, label, id }) => (
                <li key={id}>
                  <input
                    className="customers-page__filter-radio"
                    type="radio"
                    id={id}
                    name="activesFilter"
                    value={value}
                    checked={activesFilter === value}
                    onChange={this.handleFilterChange}
                  />
                  <label htmlFor={id}>{label}</label>
                </li>
              ))}
            </ul>
          </div>
          <div className="customers-page__date-filter">
            <p className="title">{t('customer_filter.start_date')}</p>
            <div>
              <RenderDatePickerField
                input={{
                  onChange: this.handleDateChange,
                  name: 'startDate',
                }}
                defaultValue={startDate}
              />
            </div>
          </div>
          <div className="customers-page__date-filter">
            <p className="title">{t('customer_filter.end_date')}</p>
            <RenderDatePickerField
              input={{
                onChange: this.handleDateChange,
                name: 'endDate',
              }}
              defaultValue={endDate}
            />
          </div>
          <div className="customers-page__select-filter">
            <p className="title">{t('customer_filter.type')}</p>
            <Select
              options={typesFilter}
              onChange={this.handleTypeChange}
              defaultValue={type}
            />
          </div>
          <div className="customers-page__search-filter">
            <p className="title">{t('customer_filter.keyword')}</p>
            <SearchBox
              name="keyword"
              defaultValue={keyword}
              onChange={this.handleKeywordChange}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default withTranslation('common')(CustomerSidebar);
